///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const GtthEntityNameValidation = (cutPattern?: RegExp): ValidatorFn => {
    const validationRule = /[^A-Za-z\d\s_\-=+*\\|/?!@#$%^&()[\]{}~.,><]/g;

    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value) {
            let newValue = control.value.replace(/^\s/g, '').replace(/\s{2,}/g, ' ');

            const pattern = cutPattern ?? validationRule;
            newValue = newValue.replace(pattern, '');

            if (newValue !== control.value) {
                control.setValue(newValue);
            }
        }

        return null;
    };
};
